module.exports = __webpack_public_path__ + "static/media/TN.91251c44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TN.svg
// module id = 2277
// module chunks = 7